// Sizing for the fields a signer types into on the signing page (OL-238).
// Senders shrink name and date boxes to fit one line of the form, often under
// 20px tall, so the input has to fit the box rather than a fixed 3-row textarea.

const SINGLE_LINE_TYPES = new Set(['date_signed', 'full_name', 'email', 'company']);
const SINGLE_LINE_PLACEHOLDERS = new Set(['date signed', 'full name', 'email address', 'company']);

// Room the box border and the input's own padding take from the height.
const BOX_CHROME_PX = 4;
const LINE_HEIGHT = 1.25;
const MULTILINE_FONT_PX = 11;
const MIN_FONT_PX = 8;
const MAX_FONT_PX = 14;

/** Name, date, email and company fields hold one line, whatever their size. */
export const isSingleLineField = (box) =>
  SINGLE_LINE_TYPES.has(box?.type) ||
  SINGLE_LINE_PLACEHOLDERS.has(String(box?.placeholder || '').trim().toLowerCase());

/**
 * How to draw a typed field in a box `heightPx` tall: the font size that fits,
 * and whether the box has room for a textarea of two or more lines.
 */
export const typedFieldLayout = (heightPx, { singleLine = false } = {}) => {
  const inner = Math.max(0, (Number(heightPx) || 0) - BOX_CHROME_PX);
  const multiline = !singleLine && inner >= 2 * MULTILINE_FONT_PX * LINE_HEIGHT;
  if (multiline) return { multiline, fontSize: MULTILINE_FONT_PX, lineHeight: LINE_HEIGHT };

  const fits = Math.floor(inner / LINE_HEIGHT);
  return {
    multiline,
    fontSize: Math.min(MAX_FONT_PX, Math.max(MIN_FONT_PX, fits)),
    lineHeight: LINE_HEIGHT,
  };
};
